import { render, staticRenderFns } from "./TopicTemplate.vue?vue&type=template&id=cf87cad2&scoped=true&"
import script from "./TopicTemplate.vue?vue&type=script&lang=js&"
export * from "./TopicTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TopicTemplate.vue?vue&type=style&index=0&id=cf87cad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf87cad2",
  null
  
)

export default component.exports